"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCustomerTemplate = exports.duplicateCustomerTemplate = exports.getCustomerTemplate = exports.updateCustomerTemplate = exports.createCustomerTemplate = exports.deleteCustomerTemplate = exports.getListOfCustomerTemplates = void 0;
var customerTemplate_1 = require("../../interfaces/customerTemplate");
var defaultResponse = {
    id: 12,
    error: '',
    message: 'Operation successfully completed',
    validationErrors: [{ errorKey: '', inputField: '' }],
    success: true,
};
var customerTemplateResponse = {
    template: {
        id: '283hdjkcbdihs834021',
        createdAt: new Date(),
        createdBy: 'user1@codebashing.com',
        updatedAt: new Date(),
        updatedBy: 'user1@codebashing.com',
        name: 'template name',
        subject: 'template subject',
        logoUrl: 'www.logo-url.com',
        imageUrl: 'www.image-url.com',
        body: 'template body',
        footer: 'template footer',
        content: 'huidwhi38297bre9dw8',
        contentType: customerTemplate_1.CustomerTemplateContentType.TOURNAMENTS,
        isReadOnly: false,
        hideImages: false,
    },
};
var customerTemplateListResponse = {
    templatesList: [
        {
            id: '6385c3892077b893312b8b60',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-11-29T08:32:09.800Z'),
            updatedAt: new Date('2022-11-29T08:32:09.800Z'),
            updatedBy: 'testy@test.com',
            name: 'dasda',
            subject: 'asdasdasda',
            logoUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/logo/emailTemplates-logo.svg',
            imageUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/emailTemplates-1.png',
            body: '<p>asdasdasdfasfafafa</p>',
            footer: '',
            contentType: customerTemplate_1.CustomerTemplateContentType.COURSES,
            content: '6384ae238408835237602e14',
            isReadOnly: false,
            hideImages: true,
        },
        {
            id: '63874b8ac1aa128f58425785',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-11-30T12:24:42.280Z'),
            updatedAt: new Date('2022-11-30T12:24:42.280Z'),
            updatedBy: 'test@test.com',
            name: 'asdasd',
            subject: 'asdasdasd',
            logoUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/logo/emailTemplates-logo.svg',
            imageUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/emailTemplates-1.png',
            body: '<p>asdasdasd</p>',
            footer: '<p>asdasds</p>',
            isReadOnly: false,
            hideImages: false,
        },
        {
            id: '63874f63c1aa128f58425795',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-11-30T12:41:07.367Z'),
            updatedAt: new Date('2022-11-30T12:41:07.367Z'),
            updatedBy: 'test@test.com',
            name: 'Arie One Two Three',
            subject: 'bla bla bla li li li',
            logoUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/logo/emailTemplates-logo.svg',
            imageUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/emailTemplates-1.png',
            body: '<p>yujyujyujyujydfsedfyujzszsdczxdczxd</p>',
            footer: '',
            isReadOnly: false,
            hideImages: false,
        },
        {
            id: '638882b15508f283c548de0b',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-12-01T10:32:17.326Z'),
            updatedAt: new Date('2022-12-01T10:32:17.326Z'),
            updatedBy: 'test@test.com',
            name: 'Template name asdasdasdasdasasdd',
            subject: 'Subject NEW',
            logoUrl: 'https://content.devcodebashing.com/courses-assets/angular.svg',
            imageUrl: 'https://content.devcodebashing.com/courses-assets/angular.svg',
            body: '<div>body</div>',
            footer: '<div>footeryeyeasdasdasdsasadadw</div>',
            isReadOnly: false,
            hideImages: false,
        },
        {
            id: '6388d31dfdde60fa7ebf7188',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-12-01T16:15:25.652Z'),
            updatedAt: new Date('2022-12-01T16:15:25.652Z'),
            updatedBy: 'test@test.com',
            name: 'Checking functionality ',
            subject: 'abcabc',
            logoUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/logo/emailTemplates-logo.svg',
            imageUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/emailTemplates-1.png',
            body: '<p>Text</p>',
            footer: '',
            contentType: customerTemplate_1.CustomerTemplateContentType.COURSES,
            content: '6384ae238408835237602e14',
            isReadOnly: true,
            hideImages: false,
        },
        {
            id: '638c6c42ab4a3806e04e53ec',
            createdBy: 'test@test.com',
            createdAt: new Date('2022-12-04T09:45:38.230Z'),
            updatedAt: new Date('2022-12-04T09:45:38.230Z'),
            updatedBy: 'test@test.com',
            name: 'arie testing 7',
            subject: 'testing 8',
            logoUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/logo/emailTemplates-logo.svg',
            imageUrl: 'https://platform-ui-spa.devcodebashing.com/icons/emailTemplates/images/emailTemplates-1.png',
            body: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras sed felis eget velit aliquet. Tellus cras adipiscing enim eu turpis egestas pretium aenean pharetra. Massa enim nec dui nunc. Senectus et netus et malesuada fames ac turpis. Massa tincidunt dui ut ornare lectus sit amet est. Vel risus commodo viverra maecenas accumsan lacus vel facilisis volutpat. Purus ut faucibus pulvinar elementum. Cursus risus at ultrices mi tempus imperdiet. A arcu cursus vitae congue mauris. Vestibulum lorem sed risus ultricies tristique <a href="www.nulla.com" rel="noopener noreferrer" target="_blank">nulla</a> aliquet enim tortor. Nisl vel pretium lectus quam id leo in vitae.</p>',
            footer: '<p>sdsddsfdfsdfsdfsdfsdfsdfsdf</p>',
            contentType: customerTemplate_1.CustomerTemplateContentType.LEADERBOARD,
            content: '633ad27b84088338ed2fe8c3',
            isReadOnly: false,
            hideImages: false,
        },
    ],
    total: 6,
};
var getListOfCustomerTemplates = function () { return customerTemplateListResponse; };
exports.getListOfCustomerTemplates = getListOfCustomerTemplates;
var deleteCustomerTemplate = function () { return defaultResponse; };
exports.deleteCustomerTemplate = deleteCustomerTemplate;
var createCustomerTemplate = function () { return customerTemplateResponse; };
exports.createCustomerTemplate = createCustomerTemplate;
var updateCustomerTemplate = function () { return customerTemplateResponse; };
exports.updateCustomerTemplate = updateCustomerTemplate;
var getCustomerTemplate = function () { return customerTemplateResponse; };
exports.getCustomerTemplate = getCustomerTemplate;
var duplicateCustomerTemplate = function () { return customerTemplateResponse; };
exports.duplicateCustomerTemplate = duplicateCustomerTemplate;
var sendCustomerTemplate = function () {
    return Promise.resolve({ success: true });
};
exports.sendCustomerTemplate = sendCustomerTemplate;
